import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import DocumentInput from '../../../../components/form/DocumentInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import PopoverColorPicker from '../../../../components/form/PopoverColorPicker'

const ThemeSection = () => {
  const { t } = useTranslation('editFormV2')

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('themeSectionTitle')}
      </Title>
      <Line />
      <Separator weight={4} />

      <Grid paddingGutter={0.5} wrap>
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('themeLogo')} field="logo" Input={DocumentInput} />
        </Col>

        <Col width="50%" wrapOn="sm">
          <FormItem label={t('themeColor')} field="themeColor" Input={PopoverColorPicker} />
        </Col>
      </Grid>
    </>
  )
}

export default ThemeSection
